import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../../styles/HeroSection.css";

function HeroSection() {
  const { t } = useTranslation();
  const [currentEmoji, setCurrentEmoji] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [typingComplete, setTypingComplete] = useState([false, false, false]);

  // Cute rotating emojis
  const emojis = ['🚀', '✨', '💡', '🎯', '🌟'];
  const floatingIcons = ['🤖', '⚙️', '🧠', '💻', '🔬', '📊'];

  // Rotate emojis every 2 seconds
  useEffect(() => {
    setIsVisible(true);

    const interval = setInterval(() => {
      setCurrentEmoji((prev) => (prev + 1) % emojis.length);
    }, 2000);
    
    return () => clearInterval(interval);
  }, [emojis.length]);

  // Staggered typing animation for title parts
  useEffect(() => {
    const timer1 = setTimeout(() => {
      setTypingComplete(prev => [true, prev[1], prev[2]]);
    }, 100);
    
    const timer2 = setTimeout(() => {
      setTypingComplete(prev => [prev[0], true, prev[2]]);
    }, 700);
    
    const timer3 = setTimeout(() => {
      setTypingComplete(prev => [prev[0], prev[1], true]);
    }, 1300);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  // Track mouse position for parallax effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <>
      <section className="hero-section">
        {/* Animated background gradient orbs */}
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
        
        {/* Floating icons with parallax */}
        {floatingIcons.map((icon, index) => (
          <div 
            key={index}
            className={`floating-icon icon-${index + 1}`}
            style={{
              transform: `translate(${mousePosition.x * (index + 1) * 0.1}px, ${mousePosition.y * (index + 1) * 0.1}px)`
            }}
          >
            {icon}
          </div>
        ))}
        
        <div className="hero-container">
          <div className={`hero-content ${isVisible ? 'fade-in' : ''}`}>
            
            {/* Launch badge */}
            {/* <div className="launch-badge">
              <span className="badge-dot"></span>
              <span className="badge-text">Launching Q1 2026</span>
            </div> */}

            {/* Main headline with gradient text and typing animation */}
            <h1 className="hero-title">
              <span className={`typing-text ${typingComplete[0] ? 'visible' : ''}`}>
                {t('homePage.heroTitle')}{' '}
              </span>
              <span className="highlight-wrapper">
                <span className={`highlight typing-text ${typingComplete[1] ? 'visible' : ''}`}>
                  {t('homePage.heroHighlight')}
                </span>
                <svg className={`highlight-underline ${typingComplete[1] ? 'visible' : ''}`} viewBox="0 0 200 12" preserveAspectRatio="none">
                  <path d="M0,7 Q50,2 100,7 T200,7" stroke="url(#gradient)" strokeWidth="3" fill="none"/>
                  <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#3b82f6" />
                      <stop offset="100%" stopColor="#8b5cf6" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>{' '}
              <span className={`typing-text ${typingComplete[2] ? 'visible' : ''}`}>
                {t('homePage.heroTitle2')}
              </span>
            </h1>
            
            {/* Subtitle */}
            <p className="hero-subtitle">
              {t('homePage.heroSubtitle')}
            </p>
          </div>
        </div>

        {/* Bottom showcase cards - spanning full width */}
        <div className="hero-showcase-bottom">
          <div className="showcase-grid">
            <div className="showcase-card card-1">
              <div className="card-icon">🤖</div>
              <div className="card-content">
                <h3 className="card-title">AI-Powered</h3>
                <p className="card-desc">Intelligent learning paths</p>
              </div>
            </div>
            <div className="showcase-card card-2">
              <div className="card-icon">⚡</div>
              <div className="card-content">
                <h3 className="card-title">Fast Track</h3>
                <p className="card-desc">Quick mastery programs</p>
              </div>
            </div>
            <div className="showcase-card card-3">
              <div className="card-icon">🎓</div>
              <div className="card-content">
                <h3 className="card-title">Expert-Led</h3>
                <p className="card-desc">Top professionals teach</p>
              </div>
            </div>
            <div className="showcase-card card-4">
              <div className="card-icon">🌍</div>
              <div className="card-content">
                <h3 className="card-title">Global Access</h3>
                <p className="card-desc">Learn anywhere, anytime</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HeroSection;
